import AvatarsContainer from "../../Componant/Ui Kit/Avtars/index";

const Avatars = () => {
  return (
    <div className="page-body">
      <AvatarsContainer />
    </div>
  );
};

export default Avatars;
